import { REQUIRED_DOCS } from "../../constants";
import { IRequiredDoc, IRequiredDocBackEndModel } from "../../types";

export const getFileSize = (size) => {
  const fileSize = size / 1024;

  if (fileSize < 1000) {
    return `${fileSize.toFixed(1)} KB`;
  }

  return `${(fileSize / 1024).toFixed(2)} MB`;
};

export function separateRequiredDocs(
  backEndRequiredDocs: IRequiredDocBackEndModel[],
) {
  const result: {
    requiredDocuments: IRequiredDoc[];
    additionalDocuments: { [key: string]: string };
  } = {
    requiredDocuments: [],
    additionalDocuments: {},
  };

  backEndRequiredDocs.forEach((receivedRequiredDoc) => {
    const foundMainRequiredDoc = REQUIRED_DOCS.find(
      (doc) => doc.name === receivedRequiredDoc.name,
    );
    if (foundMainRequiredDoc) {
      result.requiredDocuments.push({
        ...foundMainRequiredDoc,
        ...receivedRequiredDoc,
      });
    } else {
      result.additionalDocuments[receivedRequiredDoc.id!] =
        receivedRequiredDoc.name;
    }
  });

  return result;
}
